import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddcityComponent } from 'src/app/popupmodal/master/Addcity/addcity.component';
import { list } from './modal/list';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})

export class MasterComponent implements OnInit {
  statusLink;
  itemList = list;

  constructor(private router: Router,
              private dialog: MatDialog,) { 
              }

  ngOnInit(): void {
    if(sessionStorage.getItem('currentUser') === null){
      this.router.navigate(['./login'])
    }
    else{
      this.router.navigate(['./master'])
    }
  }

  onItemSelected(item) {
    if (!item.children || !item.children.length) {
        this.router.navigate([item.route]);
    }
  }

  addcity(){
    let dialogRef = this.dialog.open(AddcityComponent,{
      width: '30%',
      height:'auto',
      position: {top: '3%'},
      data : {}
    });
  
    dialogRef.afterClosed().subscribe(result => {
 
    });
  }

}
